<template>
  <div class="chengguo-item-container">
    <custom-router-link :item="info" class="chengguo-item-link" :to="{name: 'ChengguoDetails', params: {id: info.id}}" target="_blank">
      <div class="news-title">{{info.name}}</div>
      <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.chengguo-item-container {
  width: 100%;
  line-height: 36px;
  background: #fff;
  .chengguo-item-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0 20px;
    &:hover {
      background: #f8f9fa;
    }
    .publish-time {
      color: #333;
      font-size: 16px;
      margin: 8px 0;
      width: 140px;
      text-align: right;
    }
    .news-title {
      width: calc(100% - 140px - 20px);
      font-size: 16px;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      padding: 0 20px;
      &::before {
        display: block;
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: #333;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .chengguo-item-container {
    line-height: 28px;
    .chengguo-item-link {
      padding: 0;
      .publish-time {
        font-size: 12px;
        margin: 8px 0;
        width: 80px;
      }
      .news-title {
        width: calc(100% - 80px - 10px);
        font-size: 14px;
        padding: 0 14px;
        &::before {
          width: 5px;
          height: 5px;
        }
      }
    }
  }
}
</style>